interface SNSIconsProps {
  className?: string;
}
// click line icon, open line (https://lin.ee/4f3IfmZ)
// click x icon, open x (https://x.com/ThumbaJP)
export const SNSIcons = ({ className }: SNSIconsProps) => {
  return (
    <div className={`flex justify-center items-center gap-6 mt-6 ${className || ""}`}>
      <a href="https://lin.ee/4f3IfmZ" target="_blank" rel="noopener noreferrer" className="w-10">
        <img src="/assets/line.svg" alt="line icon" className="w-full h-auto" />
      </a>
      <a href="https://x.com/ThumbaJP" target="_blank" rel="noopener noreferrer" className="w-9">
        <img src="/assets/icon-x.svg" alt="x icon" className="w-full h-auto bg-black rounded-md" />
      </a>
    </div>
  );
};
